import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useGlobalContext } from "../../context/stateContext";
import { useAuth } from "../../context/Auth";
import Loading from "../../components/Loading/Loading";

const SupplierStatement = () => {
  const { supplier_id } = useParams();

  const { company } = useGlobalContext();
  const { requestWithAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [statement, setStatement] = useState([]);

  const printRef = useRef();

  const fetchSupplierStatement = async () => {
    setLoading(true);
    try {
      const data = await requestWithAuth(
        `/supplier/statement/${supplier_id}`,
        "GET"
      );
      setStatement(data);
    } catch (error) {
      setStatement([]);
      console.error("Error fetching list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSupplierStatement();
  }, []);

  const handlePrint = () => {
    const content = printRef.current;
    const printWindow = window.open('', '', 'height=600,width=900');

    if (!printWindow) return;

    printWindow.document.write(`
      <html>
        <head>
          <title>Print Statement</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ccc; padding: 8px; text-align: center; }
          </style>
        </head>
        <body>
          ${content.innerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    printWindow.onload = function () {
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <div className="p-[20px]">
      {loading ? (
        <Loading />
      ) : (
        <div className="w-[50%] mx-auto">
          <button onClick={handlePrint} className="bg-blue-400 px-4 py-2 text-white">
            Print Statement
          </button>
          <div ref={printRef} className="mt-4">
            <h3 className="text-[35px] font-bold text-gray-500">
              Life Chemist Limited
            </h3>
            <table className="text-left border-collapse">
              <tr>
                <th className="w-[130px]">Address:</th>
                <td>
                  {company?.address || "Kumasi - Ghana"}
                </td>
              </tr>
              <tr>
                <th>Email:</th>
                <td>
                  {company?.email || "info@lifechemist.com"}
                </td>
              </tr>
              <tr>
                <th>Phone Number:</th>
                <td>
                  {company?.phone_number || "020 000 0000"}
                </td>
              </tr>
              <tr>
                <th>Website:</th>
                <td>
                  {company?.website || "www.lifechemistghana.com"}
                </td>
              </tr>
            </table>
            <div className="border-t border-b border-slate-400 py-3 flex justify-between my-5 items-center">
              <h3 className="text-[25px] font-bold text-gray-500">
                Supplier Statement
              </h3>
              <div className="text-right">
                <p>Statement Date:</p>
                <h3 className="text-[25px] font-bold text-gray-500">
                  {new Date().toLocaleString() + ""}
                </h3>
              </div>
            </div>
            <table className="text-left border-collapse">
              <tr>
                <th className="w-[150px]">Supplier Name:</th>
                <td>{statement?.supplier}</td>
              </tr>
              <tr>
                <th>Opening Balance:</th>
                <td>{statement?.opening_balance}</td>
              </tr>
              <tr>
                <th>Amount Outstanding:</th>
                <td>{statement?.outstanding_balance}</td>
              </tr>
            </table>

            <table className="my-5">
              <thead>
                <tr className="bg-gray-200 ">
                  <th className="py-2">Trans. ID</th>
                  <th>Trans. Date</th>
                  <th>Invoice/Cheque #</th>
                  <th>Narration</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {statement?.statements?.map((item, index) => (
                  <tr>
                    <td className="text-center">{item?.id}</td>
                    <td className="text-center">{item?.created_at}</td>
                    <td className="text-center">{item?.statement_number}</td>
                    <td className="text-center">{item?.statement_narration}</td>
                    <td className="text-center">{item?.debit_amount}</td>
                    <td className="text-center">{item?.credit_amount}</td>
                    <td className="text-center">{item?.balance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="border-t border-b border-slate-400 py-3 my-5 ">
              <p className="text-center">
                ANY EXCEPTION OR CHANGES SHOULD BE COMMUNICATED TO THE BRANCH
                WITHIN 30 DAYS OF THIS STATEMENT OTHERWISE THE ACCOUNT WOULD BE
                PRESUMED TO BE IN ORDER.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SupplierStatement;
